var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.514 4.014a.675.675 0 0 1 .14.736l-7.189 16.964c-.33.78-1.48.615-1.579-.225l-.933-7.937-8.213-1.174c-.835-.119-.974-1.267-.191-1.582L19.78 3.861a.675.675 0 0 1 .734.153M4.867 11.32l6.677.953c.37.053.659.349.702.72l.75 6.37 5.78-13.642z",
  clipRule: "evenodd"
})));
export default SvgUserLocation;